import React from 'react';
import { StyleSheet, View, Image, Platform } from 'react-native';
import colors from '../../../config/colors';
import I18n from '../../../components/shared/i18n/I18n.component';
const calcImage = require('../../../../assets/images/calc/big_calc.png');

const WelcomeCard = () => {
	return (
		<View style={styles.card}>
            <Image
                source={calcImage}
                style={{
                    height: 60,
                    width: 65,
                }}
            />
			<View style={styles.textBlock}>
				<I18n size={15} font='medium' color='primary'>
					dashboardEmployer.welcome.title
				</I18n>
				<I18n size={22} font='bold' color='primary'>
					dashboardEmployer.michpal.title
				</I18n>
		    </View>        
		</View>
	);
};

const styles = StyleSheet.create({
	card: {
		width: '100%',
		backgroundColor: colors.white,
		borderRadius: 8,
		padding: 24,
		flexDirection: 'row-reverse',
		alignItems: 'center',
		...Platform.select({
			web: { gap: 16, boxShadow: '2px 2px 16px 0 rgba(0, 0, 0, 0.04)' },
			ios: { shadowColor: '#000', shadowOffset: { width: 2, height: 2 }, shadowOpacity: 0.04, shadowRadius: 16 },
			android: { elevation: 2 },
		}),
	},
	textBlock: {
		flexDirection: 'column',
		alignItems: 'flex-end',
		...Platform.select({ native: { marginEnd: 16 }, default: {} }),
	},
});

export default WelcomeCard;
